<template>
	<div>
		<!-- <Toast /> -->
		<Toolbar class="p-mb-4">
			<template v-slot:left>
				<Button label="返回" icon="pi pi-arrow-left" class="p-button-warning p-mr-3" @click="$router.push({name: 'submission'})" />
				<Button label="暂存" icon="pi pi-save" class="p-button-success p-mr-3" @click="saveProposal" />
			</template>

			<template v-slot:right>
				<Button label="提交申请" icon="pi pi-check" class="p-button-primary p-mr-2" @click="onSubmitClick" />
			</template>
		</Toolbar>

		<div class="p-grid">
			<div class="p-col-12 p-md-6">
				<div class="card p-fluid">
					<h4 style="color: RGB(22,105,196)">项目基本信息</h4>
					<div class="p-field">
						<label>实验名称 <span style="color: red">*</span></label>
						<InputText type="text" v-model="proposal.experimentName" />
					</div>
					<div class="p-field">
						<label>申请类型 <span style="color: red">*</span></label>
						<Dropdown v-model="proposal.applicationType" :options="applicationTypeOptions" placeholder="-- 请选择 --" />
					</div>
					<div class="p-field">
						<label>项目来源和性质 <span style="color: red">*</span></label>
						<Dropdown v-model="proposal.projectProperty" :options="projectPropertyOptions" placeholder="-- 请选择 --" />
					</div>
					<div class="p-field">
						<label>预期开展实验的日期 <span style="color: red">*</span></label>
						<Calendar v-model="expectedDate" :showTime="true" :showIcon="true" dateFormat="yy-mm-dd" />
					</div>

					<h4 style="color: RGB(22,105,196)">实验负责人信息</h4>
					<div class="p-field">
						<label>姓名 <span style="color: red">*</span></label>
						<InputText type="text" v-model="proposal.ownerName" />
					</div>
					<div class="p-field">
						<label>单位 <span style="color: red">*</span></label>
						<InputText type="text" v-model="proposal.ownerOrganization" />
					</div>
					<div class="p-field">
						<label>职称 <span style="color: red">*</span></label>
						<InputText type="text" v-model="proposal.ownerTitle" />
					</div>
					<div class="p-field">
						<label>电话 <span style="color: red">*</span></label>
						<InputText type="text" v-model="proposal.ownerPhone" />
					</div>
					<div class="p-field">
						<label>邮箱 <span style="color: red">*</span></label>
						<InputText type="text" v-model="proposal.ownerEmail" />
					</div>
					<div class="p-field">
						<label>通讯地址 <span style="color: red">*</span></label>
						<InputText type="text" v-model="proposal.ownerAddress" />
					</div>

					<h4 style="color: RGB(22,105,196)">
						<span style="vertical-align: middle; margin-right: 10px">实验参与人员</span>
						<Button type="button" label="添加" icon="pi pi-plus-circle" class="p-button-sm p-button-success" style="width: 80px; vertical-align: middle" @click="onAddParticipantClick" />
					</h4>
					<DataTable :value="proposal.participants" responsiveLayout="scroll">
						<Column field="name" header="姓名"></Column>
						<Column field="organization" header="单位"></Column>
						<Column field="phone" header="电话"></Column>
						<Column headerStyle="width: 10%">
							<template #header>
								<i class="pi pi-cog" style="font-size: 1.5em" v-tooltip.top="'操作'"></i>
							</template>
							<template #body="slotProps">
								<Button type="button" label="删除" icon="pi pi-times-circle" class="p-button-sm p-button-danger" style="width: 80px" @click="removeParticipant(slotProps.index)" />
							</template>
						</Column>
						<template #empty>
							No records found.
						</template>
					</DataTable>

					<h4 style="color: RGB(22,105,196)">样品及质子束流需求</h4>
					<div class="p-field">
						<label>样品类型及名称 <span style="color: red">*</span></label>
						<InputText type="text" v-model="proposal.sampleType" placeholder="如：IGBT芯片" />
					</div>
					<div class="p-field">
						<label>质子能量范围（0-80MeV，多个能量点请用逗号分隔） <span style="color: red">*</span></label>
						<InputText type="text" v-model="proposal.protonEnergyRange" placeholder="如：30MeV" />
					</div>
					<div class="p-field">
						<label>束流流强（flux）或辐照剂量要求 <span style="color: red">*</span></label>
						<InputText type="text" v-model="proposal.protonBeamIntensity" placeholder="如1E8 p/cm2/s  或  50 Gy" />
					</div>
					<div class="p-field">
						<label>质子束斑大小（方形束斑，2mm*2mm - 50mm*50mm）</label>
						<InputText type="text" v-model="proposal.protonBeamSpotSize" placeholder="如：2mm*2mm, 10mm*10mm" />
					</div>
					<div class="p-field">
						<label>申请束流时间（包含实验准备时间，单位：小时） <span style="color: red">*</span></label>
						<InputText type="text" v-model="proposal.requestBeamTime" placeholder="如：5" />
					</div>
					<div class="p-field">
						<label>其他设备需求（把需要的设备条件列一下）</label>
						<InputText type="text" v-model="proposal.otherDeviceRequirement" placeholder="如：低压电源 +-12V；高压2kV； 网络；真空法兰信号穿墙DB9 *2路"/>
					</div>

					<h4 style="color: RGB(22,105,196)">样品安全审查项目</h4>
					<div class="p-field">
						<label>样品形态 <span style="color: red">*</span></label>
						<div class="p-grid">
							<div class="p-col-6">
								<MultiSelect v-model="proposal.sampleState" :options="sampleStateOptions" placeholder="请选择" />
							</div>
							<div class="p-col-6">
								<InputText type="text" v-model="proposal.sampleStateDetail" placeholder="选择其他需详细说明"/>
							</div>
						</div>
					</div>
					<div class="p-field">
						<label>样品体积 <span style="color: red">*</span></label>
						<InputText type="text" v-model="proposal.sampleVolume" placeholder="如：10mm*10mm*1mm芯片 或 Φ40mm2*10mm种子" />
					</div>
					<div class="p-field">
						<label>样品重量 <span style="color: red">*</span></label>
						<div class="p-grid">
							<div class="p-col-6">
								<Dropdown v-model="proposal.sampleWeight" :options="sampleWeightOptions" placeholder="请选择" />
							</div>
							<div class="p-col-6">
								<InputText type="text" v-model="proposal.sampleWeightDetail" placeholder="多个样品详细说明"/>
							</div>
						</div>
					</div>
					<div class="p-field">
						<label>安全性申报（放射性指活度或比活度超过法规规定的豁免值） <span style="color: red">*</span></label>
						<div class="p-grid">
							<div class="p-col-6">
								<MultiSelect v-model="proposal.sampleSecurityDeclaration" :options="sampleSecurityDeclarationOptions" placeholder="请选择" />
							</div>
							<div class="p-col-6">
								<InputText type="text" v-model="proposal.sampleSecurityRadiationDetail" placeholder="放射性详细信息"/>
							</div>
						</div>
					</div>
					<div class="p-field">
						<label>样品环境特殊要求（请如实填写，未申报不可以使用） <span style="color: red">*</span></label>
						<Textarea v-model="proposal.sampleEnvironmentSpecialRequirement" :autoResize="true" rows="10" cols="30" placeholder="需要使用气瓶（写明需要的气体种类、用气量、用途）&#10;需要使用化学试剂（写明试剂的种类、用量、用途）&#10;需要使用自备样品环境设备（需要根据技安办和样品环境的要求提供详细设备资料）&#10;其他样品环境要求（如高温、高压、强磁场等） " />
					</div>
				</div>
			</div>

			<div class="p-col-12 p-md-6">
				<div class="card p-fluid">
					<h4 style="color: RGB(22,105,196)">研究背景和意义</h4>
					<div class="p-field">
						<Textarea v-model="proposal.researchBackground" placeholder="如：针对宇宙射线对芯片产品的影响" :autoResize="true" rows="18" cols="30" />
					</div>

					<h4 style="color: RGB(22,105,196)">研究内容和预期成果</h4>
					<div class="p-field">
						<Textarea v-model="proposal.researchContent" placeholder="如：完成芯片的测试" :autoResize="true" rows="18" cols="30" />
					</div>

					<h4 style="color: RGB(22,105,196)">补充说明 <span style="color: red">*</span></h4>
					<div class="p-field">
						<Textarea v-model="proposal.otherComment" placeholder="没有请填无" :autoResize="true" rows="20" cols="30" />
					</div>

					<h4 style="color: RGB(22,105,196)">附件信息</h4>
					<div class="p-grid">
						<div class="p-col-2">
							<FileUpload mode="basic" name="file" class="p-button-sm" :url="attachmentUrl()" :maxFileSize="10000000" @upload="onUpload" @error="onError" @before-send="onBeforeSend" :auto="true" chooseLabel="附件上传" />
						</div>
						<div class="p-col-10">
							<i v-if="uploading" style="margin-right: .5em; color: green" class="fa fa-spinner fa-pulse fa-2x fa-fw"></i>
							<i v-if="downloading" style="margin-right: .5em; color: RGB(22,105,196)" class="fa fa-spinner fa-pulse fa-2x fa-fw"></i>
						</div>
					</div>
					<div v-for="(item, index) in proposal.attachments" :key="index" style="font-size: 1.2em; margin-top: .2em;" class="p-field">
						<i style="margin-right: .5em" class="fa fa-file-o"></i>
						<span style="margin-right: 1em">{{ item.name }}</span>
						<span style="margin-right: 4em">{{ Math.round(item.size/1000) }}KB</span>
						<span style="margin-right: 1em; color: RGB(22,105,196); cursor: pointer;" @click="onRenameClick(index, proposal.attachments)">重命名</span>
						<span style="margin-right: 1em; color: RGB(22,105,196); cursor: pointer;" @click="onDownloadClick(item.name, item.attachmentId)">下载</span>
						<i style="margin-right: 1em; color: RGB(22,105,196); cursor: pointer;" class="fa fa-angle-double-up" @click="onMoveUpClick(index, proposal.attachments)" v-tooltip.top="'上移'"></i>
						<i style="margin-right: 1em; color: RGB(22,105,196); cursor: pointer;" class="fa fa-angle-double-down" @click="onMoveDownClick(index, proposal.attachments)" v-tooltip.top="'下移'"></i>
						<i style="color: red; cursor: pointer;" class="fa fa-times" v-tooltip.top="'删除'" @click="onDeleteAttachmentClick(index, proposal.attachments)"></i>
						<!-- <span @mouseover="hover = true" @mouseleave="hover = false" style="margin-right: .5em">
							<i v-if="hover" style="color: red; cursor: pointer;" class="fa fa-times"></i>
							<i v-else style="color: green; cursor: pointer;" class="fa fa-check-circle"></i>
						</span> -->
					</div>
				</div>
			</div>
		</div>

		<Dialog v-model:visible="addParticipantDialog" header="添加参与人员" :modal="true" class="p-fluid">
			<div class="p-field">
				<label>姓名</label>
				<InputText v-model.trim="submittingParticipant.name" autofocus />
			</div>
			<div class="p-field">
				<label>单位</label>
				<InputText v-model.trim="submittingParticipant.organization" autofocus />
			</div>
			<div class="p-field">
				<label>电话</label>
				<InputText v-model.trim="submittingParticipant.phone" autofocus />
			</div>

			<template #footer>
				<Button label="取消" icon="pi pi-times" class="p-button-text" @click="addParticipantDialog=false"/>
				<Button label="确定" icon="pi pi-check" class="p-button-primary" @click="addParticipant(submittingParticipant)" />
			</template>
		</Dialog>

		<Dialog v-model:visible="submitProposalDialog" :style="{width: '450px'}" header="消息确认" :modal="true">
			<div>
				<i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2em; color: orange; vertical-align: middle;" />
				<span style="color: orange; font-size: 1.2em;">确定要提交提案申请吗?</span>
			</div>
			<template #footer>
				<Button label="取消" icon="pi pi-times" class="p-button-text" @click="submitProposalDialog = false"/>
				<Button label="确定" icon="pi pi-check" class="p-button-primary" @click="submitProposal" />
			</template>
		</Dialog>

		<Dialog v-model:visible="deleteAttachmentDialog" :style="{width: '450px'}" header="消息确认" :modal="true">
			<div>
				<i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2em; color: orange; vertical-align: middle;" />
				<span style="color: orange; font-size: 1.2em;">确定要删除附件 "{{ selectedAttachment.name }}" 吗?</span>
			</div>
			<template #footer>
				<Button label="取消" icon="pi pi-times" class="p-button-text" @click="deleteAttachmentDialog = false"/>
				<Button label="确定" icon="pi pi-check" class="p-button-primary" @click="deleteAttachment" />
			</template>
		</Dialog>

		<Dialog v-model:visible="renameAttachmentDialog" :style="{width: '450px'}" header="重命名" :modal="true">
			<div>
				<i class="fa fa-info-circle p-mr-3" style="font-size: 1.5em; color: RGB(22,105,196); vertical-align: middle;" />
				<span style="font-size: 1.2em; vertical-align: middle;">将对附件 "{{ selectedAttachment.name }}" 进行重命名：</span>
				<InputText type="text" style="width: 100%; margin-top: .5em;" v-model="newName"/>
			</div>
			<template #footer>
				<Button label="取消" icon="pi pi-times" class="p-button-text" @click="renameAttachmentDialog = false"/>
				<Button label="确定" icon="pi pi-check" class="p-button-primary" @click="renameAttachment" />
			</template>
		</Dialog>
	</div>
</template>
<script>
import fileDownload from 'js-file-download';
import ProposalService from '../service/ProposalService';
import AuthenticationService from '../service/AuthenticationService';
const moment = require('moment');

export default {
	data() {
		return {
			intervalId: null,
			applicationTypeOptions: null,
			projectPropertyOptions: null,
			proposal: {},
			submittingParticipant: {},
			addParticipantDialog: false,
			submitProposalDialog: false,
			sampleStateOptions: ['液态', '气态', '固体', '粉末', '易碎固体', '其他'],
			sampleWeightOptions: ['1g以下', '1-10g', '10-100g', '100-1000g', '1000g以上', '多个样品'],
			sampleSecurityDeclarationOptions: [
                '放射性',
                '易燃',
                '易爆',
                '易制毒',
                '易制爆',
				'腐蚀性',
                '化学毒性',
                '强氧化性',
                '生物组织或活体',
                '生物或病毒、生物毒素',
				'水反应性',
				'无安全性要求',
            ],

			// hover: false,
			uploading: false,
			downloading: false,
			selectedIndex: 0,
			selectedAttachment: {},
			deleteAttachmentDialog: false,
			renameAttachmentDialog: false,
			newName: '',
		}
	},

	proposalService: null,
	authenticationService: null,

	created() {
		this.proposalService = new ProposalService();
		this.authenticationService = new AuthenticationService();
	},

	mounted() {
		this.applicationTypeOptions = this.proposalService.getApplicationTypeOptions();
		this.projectPropertyOptions = this.proposalService.getProjectPropertyOptions();
		this.fetchProposal();
		// this.startAutoSave();
	},

	beforeRouteUpdate() {
		// react to route changes...
		// don't forget to call next()
		console.log('beforeRouteUpdate');
		console.log(this.$route.params);
		console.log(this.$route.params.id);
	},

	beforeRouteLeave() {
		// called when the route that renders this component is about to
		// be navigated away from.
		// has access to `this` component instance.
		// this.stopAutoSave();
		console.log('beforeRouteLeave');
	},

	methods: {
		onSubmitClick() {
			let validity = this.proposalService.validateProposalSubmission(this.proposal);
			if(!validity.valid) {
				this.$toast.add({ severity: 'error', summary: '操作失败', detail: validity.message });
				return;
			}

			this.submitProposalDialog = true;
		},
		startAutoSave() {
			console.log("startAutoSave");
			this.intervalId = setInterval(() => {
				this.saveProposal();
			}, 2*60*1000);
		},
		stopAutoSave() {
			clearInterval(this.intervalId);
		},
		fetchProposal() {
			console.log('fetchProposal');
			console.log(this.$route.params.id);
			// Creating proposal
			if(this.$route.params.id === 'new')  {
				// this.proposal.expectedDate = new Date();
				// this.proposal.expectedDate.setMinutes(0, 0);
				return;
			}

			// Editing proposal
            this.proposalService.findSingleProposal(this.$route.params.id)
            .then(proposal => {
                this.proposal._id = proposal._id;
				this.proposal.experimentName = proposal.experimentName;
				this.proposal.ownerName = proposal.ownerName;
				this.proposal.ownerOrganization = proposal.ownerOrganization;
				this.proposal.ownerTitle = proposal.ownerTitle;
				this.proposal.ownerPhone = proposal.ownerPhone;
				this.proposal.ownerEmail = proposal.ownerEmail;
				this.proposal.ownerAddress = proposal.ownerAddress;
				this.proposal.participants = proposal.participants;
				this.proposal.applicationType = proposal.applicationType;
				this.proposal.projectProperty = proposal.projectProperty;
				this.proposal.expectedDate = proposal.expectedDate;
				this.proposal.sampleType = proposal.sampleType;
				this.proposal.protonEnergyRange = proposal.protonEnergyRange;
				this.proposal.protonBeamIntensity = proposal.protonBeamIntensity;
				this.proposal.protonBeamSpotSize = proposal.protonBeamSpotSize;
				this.proposal.requestBeamTime = proposal.requestBeamTime;
				this.proposal.otherDeviceRequirement = proposal.otherDeviceRequirement;
				this.proposal.researchBackground = proposal.researchBackground;
				this.proposal.researchContent = proposal.researchContent;
				this.proposal.otherComment = proposal.otherComment;

				this.proposal.sampleState = proposal.sampleState;
				this.proposal.sampleStateDetail = proposal.sampleStateDetail;
				this.proposal.sampleVolume = proposal.sampleVolume;
				this.proposal.sampleWeight = proposal.sampleWeight;
				this.proposal.sampleWeightDetail = proposal.sampleWeightDetail;
				this.proposal.sampleSecurityDeclaration = proposal.sampleSecurityDeclaration;
				this.proposal.sampleSecurityRadiationDetail = proposal.sampleSecurityRadiationDetail;
				this.proposal.sampleEnvironmentSpecialRequirement = proposal.sampleEnvironmentSpecialRequirement;
            });
        },
		saveProposal() {
			if(this.$router.currentRoute._value.name !== 'submissioncreate') {
				console.log('Router path is not correct, cannot auto save!');
				return;
			}

			if(!this.proposalService.canAutoSave(this.proposal))  {
				console.log('There is no enough data, cannot auto save!');
				return;
			}

            this.proposalService.saveProposal(this.proposal).then((proposal) => {
                // this.$router.push({name: 'submission'});
				this.$router.push({ name: 'submissioncreate', params: { id: proposal._id } });
				this.$toast.add({severity: 'info', summary: '已暂存', life: 5000});
				console.log(this.$route.params);
				console.log('Auto saved.');
            }).catch((error) => {
                if(error.response) {
					this.$toast.add({ severity: 'error', summary: '提案创建失败', detail: error.response.data.message });
				} else {
					this.$toast.add({ severity: 'error', summary: '提案创建失败', detail: error.message });
				}
            });
        },
		submitProposal() {
            this.proposalService.submitProposal(this.proposal).then(() => {
                this.$router.push({name: 'submission'});
            }).catch((error) => {
                if(error.response) {
					this.$toast.add({ severity: 'error', summary: '提案提交失败', detail: error.response.data.message });
				} else {
					this.$toast.add({ severity: 'error', summary: '提案提交失败', detail: error.message });
				}
            });
        },
		onAddParticipantClick() {
			this.submittingParticipant = {};
			this.addParticipantDialog = true;
		},
		addParticipant(participant) {
			if(!this.proposal.participants)  this.proposal.participants = [];
			this.proposal.participants.push(participant);
			this.addParticipantDialog = false;
		},
		removeParticipant(index) {
			console.log(this.proposal.participants);
            this.proposal.participants.splice(index, 1);
			console.log(this.proposal.participants);
		},
		onRenameClick(index, array) {
			this.selectedIndex = index;
			this.selectedAttachment = array[index];
			this.renameAttachmentDialog = true;
		},
		onMoveUpClick(index, array) {
			if (index === 0) {
				return;
			}
			[array[index], array[index-1]] = [array[index-1], array[index]];
		},
		onMoveDownClick(index, array) {
			if (index === array.length - 1) {
				return;
			}
			[array[index], array[index+1]] = [array[index+1], array[index]];
		},
		onDeleteAttachmentClick(index, array) {
			this.selectedIndex = index;
			this.selectedAttachment = array[index];
			this.deleteAttachmentDialog = true;
		},
		renameAttachment() {
			this.selectedAttachment.name = this.newName;
			this.renameAttachmentDialog = false;
		},
		deleteAttachment() {
			this.proposal.attachments.splice(this.selectedIndex, 1);
			this.deleteAttachmentDialog = false;
		},
		attachmentUrl() {
			return this.proposalService.attachmentUrl();
		},
		onDownloadClick(filename, id) {
			this.downloading = true;
			this.proposalService.getAttachment(id)
			.then((response) => {
				fileDownload(response.data, filename);
			}).catch(error => {
				this.$toast.add({ severity: 'error', summary: '操作失败', detail: error.message });
			}).finally(() => {
				this.downloading = false;
			});
		},
		onBeforeSend(event) {
			this.uploading = true;
			let auth = this.authenticationService.authHeaderXhr();
			let xmlhttp = event.xhr;
			xmlhttp.setRequestHeader(auth.key, auth.value);
		},
		onUpload(event) {
			this.uploading = false;

			let result = JSON.parse(event.xhr.response);
			let attachment = {
				name: result.name,
				size: result.size,
				contentType: result.contentType,
				createdAt: result.createdAt,
				createdBy: result.createdBy,
				attachmentId: result._id,
			};

			if(!this.proposal.attachments) {
				this.proposal.attachments = [];
			}
			this.proposal.attachments.push(attachment);
		},
		onError(event) {
			this.uploading = false;

			if(event.xhr && event.xhr.response) {
				let response = JSON.parse(event.xhr.response);
				this.$toast.add({severity: 'error', summary: '文件上传失败', detail: `${response.message}`});
			}
			else 
				this.$toast.add({severity: 'error', summary: '文件上传失败', detail: ''});
		},
	},

	computed: {
        expectedDate: {
            get() {
                // return this.proposal.expectedDate ? new Date(this.proposal.expectedDate) : null;
				if(this.proposal.expectedDate) {
					let d = new Date(this.proposal.expectedDate);
					d.setMinutes(0, 0);
					return d;
				} else {
					return null;
				}
            },
            set(value) {
                this.proposal.expectedDate = moment(value).format("YYYY-MM-DD HH:mm");
            }
        },
        loggedIn() {
            return this.$store.state.authentication.status.loggedIn;
        },
        userInfo() {
            return this.$store.state.authentication.user;
        }
    },

	watch: {
		$route() {
			// react to route changes...
			console.log('watch');
			console.log(this.$route.params);
			console.log(this.$route.params.id);
			
			if(this.$route.params && this.$route.params.id) {
				this.fetchProposal();
			}
		}
	}
}
</script>
